
<template>
  <div class="main-banner row ">
    <div class="col col-md-5" style="align-self: center;">
      <v-img style="width:100%" class="is-desctop" lazy-src="/static/img/bannerImg.jpg" src="/static/img/bannerImg.jpg" alt=""/>
    </div>
    <div class="text-wrapper  animate__animated animate__fadeIn  col-md-6 col-sm-12">
      <div class="banner-text__title" v-html="arr[bannerThis].title">
      </div>
      <div style="z-index: 2;">
        <div>
          <div class="banner-text__list-sub" :key="bannerThis">
            <div v-for="(item, index) in subTitleList" class="is-desctop banner-text__list-sub__item" :key="'subTitleList'+item.index">
              <span style="cursor: pointer;" @click="bannerThis = item.index" :class="Number(item.index) == Number(bannerThis) ? 'selection-text' : ''">
                {{item.title}}
              </span>
              <span style="padding: 1em;" v-if="index + 1 < subTitleList.length">·</span>
            </div>
          </div>
        </div>
        <div class="banner-text__sub-title" v-html="arr[bannerThis].title2">
        </div>
        <div class="button-text">
          <ui_btn @click="bannerFunc(arr[bannerThis].href)" class="is-desctop" type="main-btn" v-html="arr[bannerThis].buttonDescription"></ui_btn>
        </div>
      </div>
      <img style="width:100%" class="is-mobile mobile-img" src="/static/img/bannerImg.jpg" alt="">
      <div class="is-mobile btn-mobile-wrapper" style="">
        <ui_btn @click="bannerFunc(arr[bannerThis].href)" v-html="arr[bannerThis].buttonDescription"  type="gray-btn"></ui_btn>
      </div>
    </div>
    <div class="row is-mobile row-mobile">
      <div class="col mobile-wrapper-role">
        <img
          v-on:click="changeBanner(0)"
            style="cursor: pointer"
            src="/static/img/left-banner.png" />
          <div class="text-role">
            {{ arr[bannerThis].chooserDescription }}
          </div>
          <img
            v-on:click="changeBanner(1)"
            style="cursor: pointer"
            src="/static/img/right-banner.png" />
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    name: 'bannerMain',

    props: {
      arr: {
        default: []
      }
    },

    computed: {
      ...mapGetters(['getUser'])
    },
    data: () => ({
      bannerThis: 0,
      subTitleList: []
    }),
    mounted(){
      this.getSubTitle()
      setInterval(this.changeBanner(1), 180000);
    },
    methods: {
      getSubTitle(){
        for (let index in this.arr) {
          this.subTitleList.push({
            title: this.arr[index].chooserDescription,
            index: index
          })
        }
      },
      bannerFunc(href){
        if(href){
          this.$router.push(href)
        }else{
          this.$root.$emit('modal.reg')
        }
      },
      changeBanner(value){
        let count =  this.arr.length;
        if(value == 1){
          if (count == this.bannerThis + 1){
            this.bannerThis = 0;
          } else {
            this.bannerThis = this.bannerThis + 1;
          }
        } else {
          if (0 > this.bannerThis - 1){
            this.bannerThis = count - 1;
          } else {
            this.bannerThis = this.bannerThis - 1;
          }
        }
      },
    }
}
</script>

<style>
  .main-banner .text-wrapper .banner-text__title{
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 48px;
    line-height: 100%;
    overflow-wrap: break-word;
    text-align: right;

    color: #000000;
  }
  .main-banner .text-wrapper .banner-text__sub-title{
    margin-top: 15px;
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 24;
    line-height: 1.5em;
    text-align: right;
    color: rgba(0, 0, 0, 0.72);
  }
  .banner-text__list-sub{
    margin-top: 30px;
    display: flex;
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 100%;
    text-align: right;

    color: #000000;
  }
  .selection-text{
    color: #C4C4C4;
  }
  .button-text{
    text-align: right;
    margin-top: 145px;
  }
  .banner-text__list-sub{
    display: flex;
    justify-content: end;
  }
  .text-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  @media (min-width: 850px) {
    .main-banner{
      /* min-height: calc(100vh - 140px); */
    }
  }
  @media (max-width: 1650px) {
    .main-banner .text-wrapper .banner-text__title{
      font-size: 36px;
    }
    .banner-text__list-sub{
      font-size: 19px;
    }
  }
  @media (max-width: 1350px) {
    .main-banner .text-wrapper .banner-text__title{
      font-size: 27px;
    }
    .banner-text__list-sub{
      font-size: 16px;
    }
  }
  @media (max-width: 850px) {
    .btn-mobile-wrapper{
      display: flex;
      justify-content: flex-end;
    }
    .main-banner .text-wrapper .banner-text__title{
      font-size: 22px;
      margin-left: 25%;
      z-index: 2;
    }
    .main-banner .text-wrapper .banner-text__sub-title{
      font-size: 14px;
      color: #000000;
      margin-left: 55%;
    }
    .main-banner .text-wrapper .button{
      margin-left: 60%;
    }
    .main-banner{
      min-height: auto;
    }
    .mobile-img{
      position: absolute;
      width: 100%;
      z-index: 0;
      height: 380px;
      left: -32%;
      bottom: 0;
    }
    .text-wrapper{
      position: relative;
      height: 400px;
      padding-right: 40px;
    }
    .text-role{
      font-family: 'Helvetica';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      text-align: center;

      letter-spacing: 0.07em;
      color: #000000;
    }
    .row-mobile .mobile-wrapper-role{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .row-mobile .mobile-wrapper-role img{
      width: 34.19px;
      height: 34.19px;
      margin: 0 1em;
    }
    .row-mobile{
      margin-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// bannerMain.vue?b476648c